import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleBold, PiCircleBold } from 'react-icons/pi';
import { IColorProp } from 'types/components/components.interface';
import { REPAYMENTS_TYPE } from 'services/advance/types';

export interface ILabeledStatusProps {
 status: REPAYMENTS_TYPE;
}

interface ILabeledStatusParams extends IColorProp {
 status: REPAYMENTS_TYPE;
 icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
 {
  status: REPAYMENTS_TYPE.false,
  color: 'red',
  icon: <PiCircleBold />,
 },
 {
  status: REPAYMENTS_TYPE.true,
  color: 'blue',
  icon: <PiCheckCircleBold />,
 },
];

const LabelBoolen = ({ status }: ILabeledStatusProps) => {
 const { t } = useTranslation();
 const labeledParams =
  labeledStatusParams.find((params) => params.status === status) ??
  labeledStatusParams[0];
 return (
  <Label
   size="compact"
   color={labeledParams.color}
   title={t(`${labeledParams.status}`)}
  >
   {labeledParams.icon} {t(`enum.LABEL_REPAYMENTS.${labeledParams.status}`)}
  </Label>
 );
};

export default LabelBoolen;
